import { useState } from "react"
import { useGeneralContext } from "../../../Contexts/GeneralContext/GeneralProvider"
import { useSchoolAdminModalContext } from "../../../Contexts/SchoolAdminContext/SchoolAdminProvider"
import { MapUserInterface } from "../../../Interfaces/ComponentsInterfaces/SchoolAdminInterfaces"
import TrashBinIcon from '../../../Assets/TrashBinIcon.png'
import ConfirmationPopup from "../../SharedComponents/OtherComponents/ConfirmationPopUp"
import { FetchDeleteFunction } from "../../../Helpers/FetchHelpers"

function MapUser({ user, index }: MapUserInterface) {

	const { setUserToEdit, schoolUsers, setSchoolUsers } = useSchoolAdminModalContext()
	const { setCurrentModal, schoolOfUser, user: currentUser } = useGeneralContext()
	const [confirmationPopUp, setConfirmationPopUp] = useState<boolean>(false)

	const handleEditUser = () => {
		setUserToEdit(user)
		setCurrentModal('EditUser')
	}

	const deleteUser = async () => {
		if (!schoolOfUser) {
			return
		}
		// Check if current user is SuperAdmin
		if (currentUser?.admin !== 'SuperAdmin') {
			alert('Solo los superadministradores pueden eliminar usuarios')
			setConfirmationPopUp(false)
			return
		}
		try {
			const url = `${process.env.REACT_APP_BACKEND_URL}/users/${user.SK}?school_id=${schoolOfUser.SK}`;
			await FetchDeleteFunction(url)
			const updatedUsers = schoolUsers.filter((u) => u.SK !== user.SK)
			setSchoolUsers(updatedUsers)
			alert("Usuario eliminado exitosamente")
			setConfirmationPopUp(false)
		} catch (error) {
			alert('Hubo un problema al eliminar el usuario')
			setConfirmationPopUp(false)
		}
	}

	return (
		<tr>
			<td>{index}</td>
			<td>{user.name}</td>
			<td>{user.SK}</td>
			<td>
				<button type='button' onClick={handleEditUser}>
					Ver
				</button>
			</td>
			<td>
				<button type='button' onClick={() => setConfirmationPopUp(true)}>
					<img src={TrashBinIcon} alt="deleteButton"/>
				</button>
			</td>
			{confirmationPopUp && (
				<ConfirmationPopup
					valueToConfirmate={user.name}
					deletionType="user"
					deleteFunction={deleteUser}
					setIsPopUpVisible={setConfirmationPopUp}
				/>
			)}
		</tr>
	)
}

export default MapUser